var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import * as ReactDOM from 'react-dom';
import { defaultProps } from './defaults';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
import { atomicMapTooltip, atomicMapTitPos, ArrowPosStyleMap } from './atomicMap';
import Trigger from './Trigger';
import { noop } from '../../Utils/function';
var getEleAttr = function (ele) {
    if (ele && ele.getBoundingClientRect) {
        return ele.getBoundingClientRect();
    }
    return null;
};
export function findDOMNode(node) {
    if (node instanceof HTMLElement) {
        return node;
    }
    return ReactDOM.findDOMNode(node);
}
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.container = React.createRef();
        _this.wrapper = React.createRef();
        _this.handleMouseUp = function (e) {
            var el = _this.wrapper.current;
            if (e.target !== ReactDOM.findDOMNode(el) && !(el === null || el === void 0 ? void 0 : el.contains(e.target))) {
                _this.setState({ showPopper: false });
            }
        };
        _this.setEleStyle = function () {
            var _a = _this.props, placement = _a.placement, overlayStyle = _a.overlayStyle;
            var targetEle = _this.container.current && findDOMNode(_this.container.current);
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            var scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
            if (_this.state.showPopper) {
                if (!targetEle || !_this.wrapper.current || typeof targetEle == 'string')
                    return;
                var eleAttr = getEleAttr(targetEle);
                if (!eleAttr) {
                    return;
                }
                var wrapAttr = getEleAttr(_this.wrapper.current);
                if (!wrapAttr) {
                    return;
                }
                var styleObj = {
                    width: overlayStyle && overlayStyle.width ? overlayStyle.width + "px" : wrapAttr.width + "px",
                };
                var offsetTop = eleAttr.top + scrollTop - wrapAttr.height;
                var offsetLeft = eleAttr.left + scrollLeft - wrapAttr.width;
                var offsetEleTop = eleAttr.top + scrollTop + eleAttr.height / 2;
                var offsetCenterTop = offsetEleTop - wrapAttr.height / 2;
                var tipW = wrapAttr.width;
                var childW = targetEle.offsetWidth;
                var minW = Math.min(tipW, childW);
                var maxW = Math.max(tipW, childW);
                switch (placement) {
                    case 'Bottom':
                        if (tipW > childW) {
                            styleObj = Object.assign(styleObj, {
                                left: eleAttr.left + scrollLeft - (maxW - minW) / 2 + "px",
                                top: eleAttr.bottom + scrollTop + "px",
                            });
                        }
                        else {
                            styleObj = Object.assign(styleObj, {
                                left: eleAttr.left + scrollLeft + (maxW - minW) / 2 + "px",
                                top: eleAttr.bottom + scrollTop + "px",
                            });
                        }
                        break;
                    case 'BottomLeft':
                        styleObj = Object.assign(styleObj, {
                            left: eleAttr.left + scrollLeft + "px",
                            top: eleAttr.bottom + scrollTop + "px",
                        });
                        break;
                    case 'BottomRight':
                        //提示大于child left值 减小 反之增加
                        if (tipW > childW) {
                            styleObj = Object.assign(styleObj, {
                                left: eleAttr.left + scrollLeft - (maxW - minW) + "px",
                                top: eleAttr.bottom + scrollTop + "px",
                            });
                        }
                        else {
                            styleObj = Object.assign(styleObj, {
                                left: eleAttr.left + scrollLeft + (maxW - minW) + "px",
                                top: eleAttr.bottom + scrollTop + "px",
                            });
                        }
                        break;
                    case 'Top':
                        //提示大于child left值 减小 反之增加
                        if (tipW > childW) {
                            styleObj = Object.assign(styleObj, {
                                left: eleAttr.left + scrollLeft - (maxW - minW) / 2 + "px",
                                top: offsetTop + "px",
                            });
                        }
                        else {
                            styleObj = Object.assign(styleObj, {
                                left: eleAttr.left + scrollLeft + (maxW - minW) / 2 + "px",
                                top: offsetTop + "px",
                            });
                        }
                        break;
                    case 'TopLeft':
                        styleObj = Object.assign(styleObj, {
                            left: eleAttr.left + scrollLeft + "px",
                            top: offsetTop + "px",
                        });
                        break;
                    case 'TopRight':
                        //提示大于child left值 减小 反之增加
                        if (tipW > childW) {
                            styleObj = Object.assign(styleObj, {
                                left: eleAttr.left + scrollLeft - (maxW - minW) + "px",
                                top: offsetTop + "px",
                            });
                        }
                        else {
                            styleObj = Object.assign(styleObj, {
                                left: eleAttr.left + scrollLeft + (maxW - minW) + "px",
                                top: offsetTop + "px",
                            });
                        }
                        break;
                    case 'Left':
                        styleObj = Object.assign(styleObj, {
                            left: offsetLeft + "px",
                            top: offsetCenterTop + "px",
                        });
                        break;
                    case 'LeftTop':
                        styleObj = Object.assign(styleObj, {
                            left: offsetLeft + "px",
                            top: eleAttr.top + scrollTop + "px",
                        });
                        break;
                    case 'LeftBottom':
                        styleObj = Object.assign(styleObj, {
                            left: offsetLeft + "px",
                            top: eleAttr.bottom + scrollTop - wrapAttr.height + "px",
                        });
                        break;
                    case 'Right':
                        styleObj = Object.assign(styleObj, {
                            left: eleAttr.right + scrollLeft + "px",
                            top: offsetCenterTop + "px",
                        });
                        break;
                    case 'RightTop':
                        styleObj = Object.assign(styleObj, {
                            left: eleAttr.right + scrollLeft + "px",
                            top: eleAttr.top + scrollTop + "px",
                        });
                        break;
                    case 'RightBottom':
                        styleObj = Object.assign(styleObj, {
                            left: eleAttr.right + scrollLeft - 5 + "px",
                            top: eleAttr.bottom + scrollTop - wrapAttr.height + "px",
                        });
                        break;
                    default:
                        //提示大于child left值 减小 反之增加
                        if (tipW > childW) {
                            styleObj = Object.assign(styleObj, {
                                left: eleAttr.left + scrollLeft - (maxW - minW) / 2 + "px",
                                top: offsetTop + "px",
                            });
                        }
                        else {
                            styleObj = Object.assign(styleObj, {
                                left: eleAttr.left + scrollLeft + (maxW - minW) / 2 + "px",
                                top: offsetTop + "px",
                            });
                        }
                        break;
                }
                _this.wrapper.current.style.width = styleObj.width;
                if (styleObj.left)
                    _this.wrapper.current.style.left = styleObj.left;
                if (styleObj.top)
                    _this.wrapper.current.style.top = styleObj.top;
            }
        };
        _this.handleClickOutside = function (e) {
            var el = _this.container.current;
            var boolWrap = _this.wrapper.current && _this.wrapper.current.contains(e.target);
            if (el && el.contains && !el.contains(e.target) && !boolWrap) {
                if (e.nativeEvent) {
                    e.nativeEvent.stopImmediatePropagation();
                }
                if (_this.state.showPopper) {
                    _this.setState({
                        showPopper: false,
                    }, function () {
                        _this.props.onVisibleChange(false);
                    });
                }
            }
        };
        _this.handleClick = function (e) {
            if (_this.props.showLabel)
                return;
            var showPopper = _this.state.showPopper;
            if (e.nativeEvent) {
                e.nativeEvent.stopImmediatePropagation();
            }
            _this.setState({ showPopper: !showPopper });
            _this.props.onVisibleChange(!showPopper);
        };
        _this.handleFocus = function () {
            if (_this.props.showLabel)
                return;
            var showPopper = _this.state.showPopper;
            _this.setState({ showPopper: !showPopper });
            _this.props.onVisibleChange(!showPopper);
        };
        _this.showPopper = function () {
            if (_this.props.showLabel)
                return;
            clearTimeout(_this.leaveTimer);
            _this.leaveTimer = undefined;
            if (!_this.enterTimer) {
                _this.enterTimer = window.setTimeout(function () {
                    _this.setState({
                        showPopper: true,
                    }, function () {
                        _this.props.onVisibleChange(true);
                    });
                }, _this.props.mouseEnterDelay);
            }
        };
        _this.hidePopper = function () {
            if (_this.props.showLabel)
                return;
            clearTimeout(_this.enterTimer);
            _this.enterTimer = undefined;
            if (!_this.leaveTimer) {
                _this.leaveTimer = window.setTimeout(function () {
                    _this.setState({
                        showPopper: false,
                    }, function () {
                        _this.props.onVisibleChange(false);
                        _this.leaveTimer = undefined;
                    });
                }, _this.props.mouseLeaveDelay);
            }
        };
        _this.mapDirection = function () {
            var placement = _this.props.placement;
            var arrowWidth = 12;
            //箭头根据placement不同 旋转不同位置
            switch (placement) {
                case 'Bottom':
                case 'BottomLeft':
                case 'BottomRight':
                    return "translateY(" + arrowWidth / 2 + "px) rotate(45deg)";
                case 'Top':
                case 'TopLeft':
                case 'TopRight':
                    return "translateY(-" + arrowWidth / 2 + "px) rotate(45deg)";
                case 'Left':
                case 'LeftTop':
                case 'LeftBottom':
                    return "translateX(-" + arrowWidth / 2 + "px) rotate(45deg)";
                case 'Right':
                case 'RightTop':
                case 'RightBottom':
                    return "translateX(" + arrowWidth / 2 + "px) rotate(45deg)";
                default:
                    return "translateY(-" + arrowWidth / 2 + "px) rotate(45deg)";
            }
        };
        _this.getLayout = function () {
            var _a = _this.props, trigger = _a.trigger, title = _a.title, backgroundColor = _a.backgroundColor, placement = _a.placement, overlayClassName = _a.overlayClassName, _b = _a.overlayStyle, overlayStyle = _b === void 0 ? {} : _b, className = _a.className, style = _a.style, defaultVisible = _a.defaultVisible, onVisibleChange = _a.onVisibleChange, mouseEnterDelay = _a.mouseEnterDelay, mouseLeaveDelay = _a.mouseLeaveDelay, visible = _a.visible, showLabel = _a.showLabel, rest = __rest(_a, ["trigger", "title", "backgroundColor", "placement", "overlayClassName", "overlayStyle", "className", "style", "defaultVisible", "onVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "visible", "showLabel"]);
            var wrapStyle = __assign(__assign({}, style), overlayStyle);
            return (React.createElement(DivTag, __assign({ name: Tooltip.NAME, atomics: atomicMapTooltip.tooltip.concat(atomicMapTitPos[placement]), className: className + " " + overlayClassName, ref: _this.wrapper, style: wrapStyle, onMouseEnter: trigger === 'hover' ? _this.showPopper : noop, onMouseLeave: trigger === 'hover' ? _this.hidePopper : noop }, rest),
                title !== undefined && (React.createElement(DivTag, { atomics: atomicMapTooltip.title, autoPrefixedClassName: "tooltip-inner", style: { backgroundColor: backgroundColor } }, title)),
                React.createElement(DivTag, { atomics: atomicMapTooltip.arrow, autoPrefixedClassName: "tooltip-inner", style: __assign({}, ArrowPosStyleMap[placement]) },
                    React.createElement(SpanTag, { atomics: atomicMapTooltip.arrowContent, style: {
                            margin: 'auto',
                            backgroundColor: backgroundColor,
                            transform: _this.mapDirection(),
                        } }))));
        };
        _this.renderTooltip = function () {
            var _a = _this.props, trigger = _a.trigger, children = _a.children, title = _a.title, backgroundColor = _a.backgroundColor, placement = _a.placement, overlayClassName = _a.overlayClassName, _b = _a.overlayStyle, overlayStyle = _b === void 0 ? {} : _b, className = _a.className, style = _a.style, defaultVisible = _a.defaultVisible, onVisibleChange = _a.onVisibleChange, mouseEnterDelay = _a.mouseEnterDelay, mouseLeaveDelay = _a.mouseLeaveDelay, visible = _a.visible, showLabel = _a.showLabel, rest = __rest(_a, ["trigger", "children", "title", "backgroundColor", "placement", "overlayClassName", "overlayStyle", "className", "style", "defaultVisible", "onVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "visible", "showLabel"]);
            var showPopper = _this.state.showPopper;
            var layout = _this.getLayout();
            return (React.createElement(React.Fragment, null,
                React.createElement(Trigger, { forwardedRef: _this.container, onMouseEnter: trigger && trigger === 'hover' ? _this.showPopper : noop, onMouseLeave: trigger && trigger === 'hover' ? _this.hidePopper : noop, onFocus: trigger && trigger === 'focus' ? _this.handleFocus : noop, onClick: trigger && trigger === 'click' ? _this.handleClick : noop }, children &&
                    React.cloneElement(children, __assign({}, rest))),
                showPopper && ReactDOM.createPortal(layout, document.body)));
        };
        var visible = props.visible ? props.visible : props.defaultVisible;
        _this.state = {
            showPopper: visible,
        };
        _this.enterTimer = undefined;
        _this.leaveTimer = undefined;
        return _this;
    }
    Tooltip.prototype.componentDidMount = function () {
        this.setEleStyle();
        if (this.props.trigger === 'click') {
            document.addEventListener('click', this.handleClickOutside);
            document.addEventListener('mouseup', this.handleMouseUp);
        }
        var targetNode = document.body;
        var observerOptions = { subtree: true, attributes: true, attributeFilter: ['style'] };
        Tooltip.observer = new MutationObserver(this.resetPos.bind(this));
        Tooltip.observer.observe(targetNode, observerOptions);
    };
    Tooltip.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.visible === true) {
            this.showPopper();
        }
        else if (nextProps.visible === false) {
            this.hidePopper();
        }
    };
    Tooltip.prototype.componentDidUpdate = function () {
        this.setEleStyle();
    };
    Tooltip.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleClickOutside);
        document.removeEventListener('mouseup', this.handleMouseUp);
        Tooltip.observer.disconnect();
    };
    Tooltip.prototype.resetPos = function () {
        this.setEleStyle();
    };
    Tooltip.prototype.render = function () {
        return React.createElement(React.Fragment, null, this.renderTooltip());
    };
    Tooltip.defaultProps = defaultProps;
    Tooltip.NAME = 'tooltip';
    Tooltip.displayName = 'Tooltip';
    Tooltip.observer = null;
    return Tooltip;
}(PureComponent));
export { Tooltip };
